import React from 'react';
import { ApolloError } from '@apollo/client';
import ErrorPlaceholder from 'assets/images/errorPlaceholder.svg';
import { getApolloErrorMessage } from 'helpers/remapApolloErrors';
import { EmptyPlaceholder } from '../EmptyPlaceholder';

export const GlobalErrorView = ({ error }: { error?: ApolloError | Error }) => {
  let errorMessage = error?.message;
  if (error instanceof ApolloError) {
    const apolloErrorMessage = getApolloErrorMessage(error);
    errorMessage += ' - ' + (apolloErrorMessage === 'GENERIC_ERROR_MESSAGE' ? '' : apolloErrorMessage);
  }
  return (
    <EmptyPlaceholder
      title={'Oops! A Glitch in the Matrix'}
      removeBorder
      buttonTitle={'Reload Page'}
      image={ErrorPlaceholder}
      buttonAction={() => window.location.reload()}
      bottomText={error && <em style={{ fontSize: 12 }}>Error: {errorMessage}</em>}>
      <div style={{ marginBottom: 24 }}>
        It appears there&apos;s a hiccup in rendering this page. No worries, we can sort it out. Reloading the page
        might help.
      </div>
    </EmptyPlaceholder>
  );
};
